import { SelectionModel } from '@angular/cdk/collections/selection-model';
import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { NotificationsService } from 'angular2-notifications';
import { Subject } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { MappingCurrentAccountBilletDialog } from '../mappingCurrentAccountBillet-dialog/mappingCurrentAccountBillet-dialog.component';
import { CurrentAccountBilletModel } from '../model/currentAccountBilletModel';
import { FilterTableModel } from '../model/filterTableModel';
import { MappingCurrentAccountBilletService } from '../services/mappingCurrentAccountBillet.service';

@Component({
    selector: 'mappingCurrentAccountBillet-listContract',
    templateUrl: './mappingCurrentAccountBillet-listContract.component.html',
    styleUrls: [],
})
export class MappingCurrentAccountBilletListContractComponent {
    @Input() public contractList: any[];
    @Input() public contractListSorted: any[];
    @Input() isLoading = new Subject<boolean>();
    @Input() filterTable: FilterTableModel;
    @Input() mappType: number;

    public mappingModel: CurrentAccountBilletModel[] = null;
    constructor(
        private _mappingCurrentAccountBilletService: MappingCurrentAccountBilletService,
        private _loaderService: LoaderService,
        private _notificationsService: NotificationsService,
        public dialog: MatDialog,
        private _config: AppConfig,
    ) {}

    public onClickContract(contractId: string) {
        this.Load(true);
        this._mappingCurrentAccountBilletService.GetByContractId(contractId).subscribe((result) => {
            if (result.success) {
                if (result.data.length == 0) {
                    this._notificationsService.warn('Não existe mapeamento para este contrato');
                } else {
                    this.mappingModel = result.data;
                    this.openMappingDataDialog(contractId);
                }
            }
            this.Load(false);
        });
    }

    public goToAfsContract(contractId: string): void {
        this.redirect(`${this._config.urlOldAfs}AccountsReceiving/AccountsReceiving/?contractId=${contractId}`);
    }

    private redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(!!window.open(url, target));
            } catch (e) {
                reject(e);
            }
        });
    }

    countSelected() {
        return this.contractList.filter((row: any) => row.selected).length;
    }

    isAllSelected() {
        return this.countSelected() == this.contractList.length;
    }

    changeSelected(item: any) {
        item.selected = !item.selected;
    }
    masterToggle() {
        let allSelected = this.isAllSelected();

        this.contractList.forEach((row: any) => {
            row.selected = !allSelected;
        });
    }

    public onGenerate(contractId: string) {
        if (!contractId) return;
        this.Load(true);
        try {
            this._mappingCurrentAccountBilletService
                .Generate(contractId, Boolean(this.mappType))
                .subscribe((result) => {
                    if (result.success) {
                        if (result.data) {
                            this._notificationsService.success('Mapeado');
                        } else {
                            this._notificationsService.warn('Não conseguiu gerar o mapeamento.');
                            console.log(result);
                        }
                    } else {
                        this._notificationsService.warn('Não conseguiu gerar o mapeamento..');
                        console.log(result);
                    }
                    this.Load(false);
                });
        } catch (error) {
            this._notificationsService.warn('Não conseguiu gerar o mapeamento...');
            console.log(error);
        }
    }

    private Load(value: boolean) {
        if (value) {
            this._loaderService.show();
        } else {
            this._loaderService.hide();
        }
        this.isLoading = this._loaderService.isLoading;
    }

    onSortData(sort: Sort) {
        if (!sort.active || sort.direction === '') {
            return;
        }
        const data = this.contractList.slice();
        this.contractListSorted = data.sort((a, b) => {
            const aValue = (a as any)[sort.active];
            const bValue = (b as any)[sort.active];
            return (aValue < bValue ? -1 : 1) * (sort.direction === 'asc' ? 1 : -1);
        });
    }

    public onGenerateList() {
        let contractIds = this.contractList.filter((c) => c.selected).map((c) => c.contractId);
        if (!contractIds) return;

        if (contractIds.length == 0) {
            this._notificationsService.warn('Selecione pelomenos um contrato');
            return;
        }

        this._notificationsService.success(
            `Aguarde... este processo pode demorar. \n [${this.contractList.length}] itens`,
        );
        this.Load(true);
        try {
            this._mappingCurrentAccountBilletService
                .GenerateList(contractIds, Boolean(this.mappType))
                .subscribe((result) => {
                    if (result.success) {
                        if (result.data) {
                            this._notificationsService.success('Mapeado');
                        } else {
                            this._notificationsService.warn('Não conseguiu gerar o mapeamento.');
                            console.log(result);
                        }
                    } else {
                        this._notificationsService.warn('Não conseguiu gerar o mapeamento..');
                        console.log(result);
                    }
                    this.Load(false);
                });
        } catch (error) {
            this._notificationsService.warn('Não conseguiu gerar o mapeamento...');
            console.log(error);
        }
    }

    openMappingDataDialog(contractId: string): void {
        let contractSelected = this.contractList.find((c) => c.contractId == contractId);

        const dialogRef = this.dialog.open(MappingCurrentAccountBilletDialog, {
            width: '900px',
            data: { mapping: this.mappingModel, contractSelected: contractSelected.description },
        });

        dialogRef.afterClosed().subscribe((result) => {
            console.log('The dialog was closed');
        });
    }
}
